export const ListIcon = ({ width = 16 }) => (
	<svg
      aria-hidden="true"
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        d="M11 9h6
			m-6 3h6
			m-6 3h6
			M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z
		"
      />
    </svg>
);
